<app-card class="flex-basis-100 mb-12">
  <div cardTitle i18n>Informations construction</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="metadata?.entityType || originalMetadata?.entityType"
      >
        <span class="card__label" i18n>Client</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.entityType,
            }"
            >{{ getConstructionEntityTypeLabel(metadata.entityType) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.entityType &&
              originalMetadata?.entityType !== metadata.entityType
            "
            >{{
              getConstructionEntityTypeLabel(originalMetadata.entityType)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.insuranceStartDate || originalMetadata?.insuranceStartDate
        "
      >
        <span class="card__label" i18n>Date de début de l'assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.insuranceStartDate,
            }"
            >{{ metadata?.insuranceStartDate | date: DATE_FORMAT }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.insuranceStartDate &&
              originalMetadata?.insuranceStartDate !==
                metadata.insuranceStartDate
            "
            >{{
              originalMetadata?.insuranceStartDate | date: DATE_FORMAT
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.constructionStartDate ||
          originalMetadata?.constructionStartDate
        "
      >
        <span class="card__label" i18n>Début des travaux</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.constructionStartDate,
            }"
            >{{ metadata?.constructionStartDate | date: DATE_FORMAT }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.constructionStartDate &&
              originalMetadata?.constructionStartDate !==
                metadata.constructionStartDate
            "
            >{{
              originalMetadata?.constructionStartDate | date: DATE_FORMAT
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.constructionEndDate || originalMetadata?.constructionEndDate
        "
      >
        <span class="card__label" i18n>Fin des travaux</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.constructionEndDate,
            }"
            >{{ metadata?.constructionEndDate | date: DATE_FORMAT }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.constructionEndDate &&
              originalMetadata?.constructionEndDate !==
                metadata.constructionEndDate
            "
            >{{
              originalMetadata?.constructionEndDate | date: DATE_FORMAT
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.gradualConstruction !== null &&
            metadata?.gradualConstruction !== undefined) ||
          (originalMetadata?.gradualConstruction !== null &&
            originalMetadata?.gradualConstruction !== undefined)
        "
      >
        <span i18n class="card__label"
          >Les travaux sont-ils réceptionnés en une fois ou par étape ?</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.gradualConstruction === null ||
                  originalMetadata.gradualConstruction === undefined),
            }"
          >
            <span *ngIf="metadata.gradualConstruction" i18n> En étapes </span>
            <span *ngIf="!metadata.gradualConstruction" i18n>
              En une fois
            </span>
          </span>
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.gradualConstruction &&
              originalMetadata?.gradualConstruction !==
                metadata.gradualConstruction
            "
          >
            <span *ngIf="originalMetadata.gradualConstruction" i18n>
              En étapes
            </span>
            <span *ngIf="!originalMetadata.gradualConstruction" i18n>
              En une fois
            </span>
          </span>
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="metadata?.constructionType || originalMetadata?.constructionType"
      >
        <span class="card__label" i18n>Type de construction</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.constructionType,
            }"
            >{{ getConstructionEnumTypeLabel(metadata.constructionType) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.constructionType &&
              originalMetadata?.constructionType !== metadata.constructionType
            "
            >{{
              getConstructionEnumTypeLabel(originalMetadata.constructionType)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.constructionTypeInfo ||
          originalMetadata?.constructionTypeInfo
        "
      >
        <span class="card__label" i18n
          >Description du type de construction</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.constructionTypeInfo,
            }"
            >{{ metadata.constructionTypeInfo }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.constructionTypeInfo &&
              originalMetadata?.constructionTypeInfo !==
                metadata.constructionTypeInfo
            "
            >{{ originalMetadata.constructionTypeInfo }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.cadastralNumber || originalMetadata?.cadastralNumber"
      >
        <span class="card__label" i18n>Numéro du cadastre</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.cadastralNumber,
            }"
            >{{ metadata.cadastralNumber }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.cadastralNumber &&
              originalMetadata?.cadastralNumber !== metadata.cadastralNumber
            "
            >{{ originalMetadata.cadastralNumber }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.address || originalMetadata?.address"
      >
        <span class="card__label" i18n>Adresse</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.address,
            }"
            >{{ metadata.address }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.address &&
              originalMetadata?.address !== metadata.address
            "
            >{{ originalMetadata.address }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.postalCode || originalMetadata?.postalCode"
      >
        <span class="card__label" i18n>Code postal</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.postalCode,
            }"
            >{{ metadata.postalCode }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.postalCode &&
              originalMetadata?.postalCode !== metadata.postalCode
            "
            >{{ originalMetadata.postalCode }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.constructionStarted !== null &&
            metadata?.constructionStarted !== undefined) ||
          (originalMetadata?.constructionStarted !== null &&
            originalMetadata?.constructionStarted !== undefined)
        "
      >
        <span class="card__label" i18n
          >Les travaux ont-ils déjà commencé ?</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.constructionStarted === null ||
                  originalMetadata.constructionStarted === undefined),
            }"
            >{{ getBooleanLabel(metadata.constructionStarted) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.constructionStarted &&
              originalMetadata?.constructionStarted !==
                metadata.constructionStarted
            "
            >{{ getBooleanLabel(originalMetadata.constructionStarted) }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>
<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    displayEntity(metadata?.architect) ||
    displayEntity(originalMetadata?.architect)
  "
>
  <div cardTitle i18n>Architecte</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          metadata?.architect?.fullName || originalMetadata?.architect?.fullName
        "
      >
        <span class="card__label" i18n>Nom complet</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.architect?.fullName,
            }"
            >{{ metadata?.architect?.fullName }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.architect?.fullName &&
              originalMetadata?.architect?.fullName !==
                metadata.architect?.fullName
            "
            >{{ originalMetadata?.architect?.fullName }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.architect?.phoneNumber ||
          originalMetadata?.architect?.phoneNumber
        "
      >
        <span class="card__label" i18n>N° de téléphone</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.architect?.phoneNumber,
            }"
            >{{ metadata?.architect?.phoneNumber }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.architect?.phoneNumber &&
              originalMetadata?.architect?.phoneNumber !==
                metadata.architect?.phoneNumber
            "
            >{{ originalMetadata?.architect?.phoneNumber }}</span
          >
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="metadata?.architect?.email || originalMetadata?.architect?.email"
      >
        <span class="card__label" i18n>Email</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.architect?.email,
            }"
            >{{ metadata?.architect?.email }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.architect?.email &&
              originalMetadata?.architect?.email !== metadata.architect?.email
            "
            >{{ originalMetadata?.architect?.email }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.architect?.address || originalMetadata?.architect?.address
        "
      >
        <span class="card__label" i18n>Adresse</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.architect?.address,
            }"
            >{{ metadata?.architect?.address }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.architect?.address &&
              originalMetadata?.architect?.address !==
                metadata.architect?.address
            "
            >{{ originalMetadata?.architect?.address }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>
<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    displayEntity(metadata?.civilEngineer) ||
    displayEntity(originalMetadata?.civilEngineer)
  "
>
  <div cardTitle i18n>Ingénieur civil</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          metadata?.civilEngineer?.fullName ||
          originalMetadata?.civilEngineer?.fullName
        "
      >
        <span class="card__label" i18n>Nom complet</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.civilEngineer?.fullName,
            }"
            >{{ metadata?.civilEngineer?.fullName }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.civilEngineer?.fullName &&
              originalMetadata?.civilEngineer?.fullName !==
                metadata.civilEngineer?.fullName
            "
            >{{ originalMetadata?.civilEngineer?.fullName }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.civilEngineer?.phoneNumber ||
          originalMetadata?.civilEngineer?.phoneNumber
        "
      >
        <span class="card__label" i18n>N° de téléphone</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                !originalMetadata.civilEngineer?.phoneNumber,
            }"
            >{{ metadata?.civilEngineer?.phoneNumber }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.civilEngineer?.phoneNumber &&
              originalMetadata?.civilEngineer?.phoneNumber !==
                metadata.civilEngineer?.phoneNumber
            "
            >{{ originalMetadata?.civilEngineer?.phoneNumber }}</span
          >
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          metadata?.civilEngineer?.email ||
          originalMetadata?.civilEngineer?.email
        "
      >
        <span class="card__label" i18n>Email</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.civilEngineer?.email,
            }"
            >{{ metadata?.civilEngineer?.email }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.civilEngineer?.email &&
              originalMetadata?.civilEngineer?.email !==
                metadata.civilEngineer?.email
            "
            >{{ originalMetadata?.civilEngineer?.email }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.civilEngineer?.address ||
          originalMetadata?.civilEngineer?.address
        "
      >
        <span class="card__label" i18n>Adresse</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.civilEngineer?.address,
            }"
            >{{ metadata?.civilEngineer?.address }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.civilEngineer?.address &&
              originalMetadata?.civilEngineer?.address !==
                metadata.civilEngineer?.address
            "
            >{{ originalMetadata?.civilEngineer?.address }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    displayEntity(metadata?.projectOwner) ||
    displayEntity(originalMetadata?.projectOwner)
  "
>
  <div cardTitle i18n>Maître d'ouvrage</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          metadata?.projectOwner?.type || originalMetadata?.projectOwner?.type
        "
      >
        <span class="card__label" i18n>Type</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.projectOwner?.type,
            }"
            >{{
              getConstructionProjectOwnerTypeLabel(metadata.projectOwner?.type)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.projectOwner?.type &&
              originalMetadata?.projectOwner?.type !==
                metadata.projectOwner?.type
            "
            >{{
              getConstructionProjectOwnerTypeLabel(
                originalMetadata.projectOwner?.type
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.projectOwner?.fullName ||
          originalMetadata?.projectOwner?.fullName
        "
      >
        <span class="card__label" i18n>Nom complet</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.projectOwner?.fullName,
            }"
            >{{ metadata?.projectOwner?.fullName }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.projectOwner?.fullName &&
              originalMetadata?.projectOwner?.fullName !==
                metadata.projectOwner?.fullName
            "
            >{{ originalMetadata?.projectOwner?.fullName }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.projectOwner?.phoneNumber ||
          originalMetadata?.projectOwner?.phoneNumber
        "
      >
        <span class="card__label" i18n>N° de téléphone</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.projectOwner?.phoneNumber,
            }"
            >{{ metadata?.projectOwner?.phoneNumber }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.projectOwner?.phoneNumber &&
              originalMetadata?.projectOwner?.phoneNumber !==
                metadata.projectOwner?.phoneNumber
            "
            >{{ originalMetadata?.projectOwner?.phoneNumber }}</span
          >
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          metadata?.projectOwner?.email || originalMetadata?.projectOwner?.email
        "
      >
        <span class="card__label" i18n>Email</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.projectOwner?.email,
            }"
            >{{ metadata?.projectOwner?.email }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.projectOwner?.email &&
              originalMetadata?.projectOwner?.email !==
                metadata.projectOwner?.email
            "
            >{{ originalMetadata?.projectOwner?.email }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.projectOwner?.address ||
          originalMetadata?.projectOwner?.address
        "
      >
        <span class="card__label" i18n>Adresse</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.projectOwner?.address,
            }"
            >{{ metadata?.projectOwner?.address }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.projectOwner?.address &&
              originalMetadata?.projectOwner?.address !==
                metadata.projectOwner?.address
            "
            >{{ originalMetadata?.projectOwner?.address }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    displayInsuranceInfo(metadata) || displayInsuranceInfo(originalMetadata)
  "
>
  <div cardTitle i18n>Informations sur l'assurance souhaitée</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          (metadata?.constructionWorkInsuranceWanted !== null &&
            metadata?.constructionWorkInsuranceWanted !== undefined) ||
          (originalMetadata?.constructionWorkInsuranceWanted !== null &&
            originalMetadata?.constructionWorkInsuranceWanted !== undefined)
        "
      >
        <span class="card__label" i18n>Assurance travaux de construction</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.constructionWorkInsuranceWanted === null ||
                  originalMetadata.constructionWorkInsuranceWanted ===
                    undefined),
            }"
            >{{
              getBooleanLabel(metadata.constructionWorkInsuranceWanted)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.constructionWorkInsuranceWanted !== undefined &&
              originalMetadata?.constructionWorkInsuranceWanted !== null &&
              originalMetadata?.constructionWorkInsuranceWanted !==
                metadata.constructionWorkInsuranceWanted
            "
            >{{
              getBooleanLabel(originalMetadata.constructionWorkInsuranceWanted)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.projectOwnerCivilResponsibility !== null &&
            metadata?.projectOwnerCivilResponsibility !== undefined) ||
          (originalMetadata?.projectOwnerCivilResponsibility !== null &&
            originalMetadata?.projectOwnerCivilResponsibility !== undefined)
        "
      >
        <span i18n class="card__label"
          >Assurance responsabilité civile constructeur du maître
          d'ouvrage ?</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.projectOwnerCivilResponsibility === null ||
                  originalMetadata.projectOwnerCivilResponsibility ===
                    undefined),
            }"
            >{{
              getBooleanLabel(metadata.projectOwnerCivilResponsibility)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.projectOwnerCivilResponsibility !== undefined &&
              originalMetadata?.projectOwnerCivilResponsibility !== null &&
              originalMetadata?.projectOwnerCivilResponsibility !==
                metadata.projectOwnerCivilResponsibility
            "
            >{{
              getBooleanLabel(originalMetadata.projectOwnerCivilResponsibility)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.nearAdjuvant !== null &&
            metadata?.nearAdjuvant !== undefined) ||
          (originalMetadata?.nearAdjuvant !== null &&
            originalMetadata?.nearAdjuvant !== undefined)
        "
      >
        <span i18n class="card__label"
          >Le pouvoir adjudicateur est-il propriétaire des travaux sur le
          terrain ou à proximité immédiate des travaux réalisés ?</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.nearAdjuvant === null ||
                  originalMetadata.nearAdjuvant === undefined),
            }"
            >{{ getBooleanLabel(metadata.nearAdjuvant) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.nearAdjuvant !== undefined &&
              originalMetadata?.nearAdjuvant !== null &&
              originalMetadata?.nearAdjuvant !== metadata.nearAdjuvant
            "
            >{{ getBooleanLabel(originalMetadata.nearAdjuvant) }}</span
          >
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          (metadata?.fireNaturalDisasterInsurance !== null &&
            metadata?.fireNaturalDisasterInsurance !== undefined) ||
          (originalMetadata?.fireNaturalDisasterInsurance !== null &&
            originalMetadata?.fireNaturalDisasterInsurance !== undefined)
        "
      >
        <span i18n class="card__label"
          >Dans les cantons sans établissements cantonaux d'assurance: les
          risques Incendie/événements naturels doivent-ils être assuré ?</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.fireNaturalDisasterInsurance === null ||
                  originalMetadata.fireNaturalDisasterInsurance === undefined),
            }"
            >{{ getBooleanLabel(metadata.fireNaturalDisasterInsurance) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.fireNaturalDisasterInsurance !== undefined &&
              originalMetadata?.fireNaturalDisasterInsurance !== null &&
              originalMetadata?.fireNaturalDisasterInsurance !==
                metadata.fireNaturalDisasterInsurance
            "
            >{{
              getBooleanLabel(originalMetadata.fireNaturalDisasterInsurance)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.ownerWithoutInsurance !== null &&
            metadata?.ownerWithoutInsurance !== undefined) ||
          (originalMetadata?.ownerWithoutInsurance !== null &&
            originalMetadata?.ownerWithoutInsurance !== undefined)
        "
      >
        <span i18n class="card__label"
          >Le propriétaire participe-t-il activement à des travaux d'excavation
          ou à des travaux sur des structures porteuses sans assurance
          responsabilité adéquate ?</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.ownerWithoutInsurance === null ||
                  originalMetadata.ownerWithoutInsurance === undefined),
            }"
            >{{ getBooleanLabel(metadata.ownerWithoutInsurance) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.ownerWithoutInsurance !== undefined &&
              originalMetadata?.ownerWithoutInsurance !== null &&
              originalMetadata?.ownerWithoutInsurance !==
                metadata.ownerWithoutInsurance
            "
            >{{ getBooleanLabel(originalMetadata.ownerWithoutInsurance) }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="displayRiskInfo(metadata) || displayRiskInfo(originalMetadata)"
>
  <div cardTitle i18n>Questions relatives aux risques</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="metadata?.totalCost || originalMetadata?.totalCost"
      >
        <span class="card__label" i18n>Coût total</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.totalCost,
            }"
            >{{ metadata.totalCost }}
            <ng-container *ngIf="metadata.totalCost">CHF</ng-container></span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.totalCost &&
              originalMetadata?.totalCost !== metadata.totalCost
            "
            >{{ originalMetadata.totalCost }}
            <ng-container>CHF</ng-container></span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.nearestStructure || originalMetadata?.nearestStructure"
      >
        <span i18n class="card__label"
          >Distance à la structure tertiaire la plus proche, existante ou en
          construction</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.nearestStructure,
            }"
            >{{
              getNearestStructureDistanceLabel(metadata.nearestStructure)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.nearestStructure &&
              originalMetadata?.nearestStructure !== metadata.nearestStructure
            "
            >{{
              getNearestStructureDistanceLabel(
                originalMetadata.nearestStructure
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.topography || originalMetadata?.topography"
      >
        <span class="card__label" i18n>Topography</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.topography,
            }"
            >{{ getTopographyLabel(metadata.topography) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.topography &&
              originalMetadata?.topography !== metadata.topography
            "
            >{{ getTopographyLabel(originalMetadata.topography) }}</span
          >
        </div>
      </div>
    </div>
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="
          (metadata?.isCivilEngineering !== null &&
            metadata?.isCivilEngineering !== undefined) ||
          (originalMetadata?.isCivilEngineering !== null &&
            originalMetadata?.isCivilEngineering !== undefined)
        "
      >
        <span class="card__label" i18n>Projet de génie civil</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.isCivilEngineering === null ||
                  originalMetadata.isCivilEngineering === undefined),
            }"
            >{{ getBooleanLabel(metadata.isCivilEngineering) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.isCivilEngineering !== undefined &&
              originalMetadata?.isCivilEngineering !== null &&
              originalMetadata?.isCivilEngineering !==
                metadata.isCivilEngineering
            "
            >{{ getBooleanLabel(originalMetadata.isCivilEngineering) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.plannedDemolition !== null &&
            metadata?.plannedDemolition !== undefined) ||
          (originalMetadata?.plannedDemolition !== null &&
            originalMetadata?.plannedDemolition !== undefined)
        "
      >
        <span i18n class="card__label"
          >La démolition de bâtiments entiers ou de parties de bâtiments ou
          d'ouvrages est prévue ?</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata.plannedDemolition === null ||
                  originalMetadata.plannedDemolition === undefined),
            }"
            >{{ getBooleanLabel(metadata.plannedDemolition) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.plannedDemolition !== undefined &&
              originalMetadata?.plannedDemolition !== null &&
              originalMetadata?.plannedDemolition !== metadata.plannedDemolition
            "
            >{{ getBooleanLabel(originalMetadata.plannedDemolition) }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>
